import { c as _c } from "react/compiler-runtime";
import { Suspense, useLayoutEffect, useRef, type ReactNode } from "react";
import { BlacksmithLogomarkAnimationSVG } from "./BlacksmithLogoSVG";
import { SidebarInset } from "./ui/sidebar";
import { cn } from "@repo/blacksmith-ui/cn";

/**
 * The main pane and its Suspense boundary stay mounted across route changes.
 * React only holds the current page through a transition when the boundary
 * that would catch the next page's suspension is already on screen; a
 * remounted boundary shows its fallback the moment the route commits, so
 * every route change flashed a blank pane before the next page appeared.
 */
export function SidebarMainContent(t0) {
  const $ = _c(11);
  const {
    children,
    fixedMain,
    scrollResetKey
  } = t0;
  const mainRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const main = mainRef.current;
      if (!main) {
        return;
      }
      main.scrollTop = 0;
      main.scrollLeft = 0;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== scrollResetKey) {
    t2 = [scrollResetKey];
    $[1] = scrollResetKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const t3 = fixedMain ? "min-h-0 overflow-hidden" : "overflow-y-auto [scrollbar-gutter:stable]";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("flex-1 bg-transparent!", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div data-slot="sidebar-main-loading" className="flex h-full items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children) {
    t6 = <Suspense fallback={t5}>{children}</Suspense>;
    $[6] = children;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <SidebarInset ref={mainRef} className={t4}>{t6}</SidebarInset>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}